import axios, { AxiosRequestConfig } from 'axios';

const httpDelete = async (
  url: string,
  data?: any,
  config?: AxiosRequestConfig
) => {
  const response = await axios.delete(url, { data, ...config });
  return response;
};

export default httpDelete;
